import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_9chgehsm7b: FaireCollectionEntity = {
  token: "pbc_9chgehsm7b",
  type: "collection",
  name: "backyard bird",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c378232a772778e6680e7409990248a027bcb3f7e107943ffeeac432ef9c4bd4.jpeg",
  itemCount: 10,
  brandToken: "b_mmdanrh9jf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:09:23.312Z",
    importedBy: "entity-db-import-collections",
  },
};
